import { useState } from 'react';

import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow, TextField, FormControlLabel, FormLabel, RadioGroup, Typography, Radio, List, ListItem, ListItemText  } from '@mui/material';

import { usePages } from '../hooks/usePages';

import { TablePaginationActions } from '../helpers/TablePaginationActions';

import { TablePaddingStyle, TableTheadStyle } from '../styles/TableStyle';
import { DialogActionsStyle, DialogContentStyle } from '../styles/DialogStyle';

import { BuscarAmparo } from '../connections/comun/AmparoConnection';

import { AmparoProps, BuscarAmparoParams } from '../interfaces/comun/AmparoInterface';

interface Props {
    openDialog:              boolean;
    autoridad:              number;
    handleCloseDialog:       () => void;
    seleccionarAmparo:      ( Amparo: AmparoProps ) => void;
}

type BuscarPorType = 'NumeroAuxiliarAmparo' | 'NumeroAmparoOrigen' | 'NumeroExpediente';

export const DialogBuscarAmparo = ( { openDialog, autoridad, handleCloseDialog, seleccionarAmparo }: Props ) => {

    const [rows, setRows] = useState<AmparoProps[]>( [] );

    const [buscarPor, setBuscarPor] = useState<BuscarPorType>( 'NumeroAuxiliarAmparo' );
    const [referencia, setReferencia] = useState( '' );
  
    const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage, resetPage } = usePages( 5 );    

    const [loading, setLoading] = useState( false );

    const handleSeleccionar = ( amparo: AmparoProps ) => {

        seleccionarAmparo( amparo )
        CerrarModal();

    }
  
    const Buscar = async () => {

        setLoading( true );

        setRows( [ ] );
        resetPage();

        const params: BuscarAmparoParams = {           
            idAutoridad: autoridad,
            numeroAmparo: buscarPor === 'NumeroAuxiliarAmparo' ? referencia : '',
            numeroAmparoOrigen: buscarPor === 'NumeroAmparoOrigen' ? referencia : '',
            numeroExpediente: buscarPor === 'NumeroExpediente' ? referencia : '',
        };

        await BuscarAmparo( params ).then( resp => {           

            setTimeout(() => {

                setRows( resp );
                
                setLoading( false );

            }, 700);                

        });
    }    

    const CerrarModal = () => {

        setReferencia( '' );
        setBuscarPor( 'NumeroAuxiliarAmparo' );
        setRows( [] );

        handleCloseDialog();        
     
    }

    return (
        <>
            <Dialog 
                maxWidth='lg' 
                fullWidth={true}
                open={ openDialog } 
            >

                <DialogTitle>
                    Buscar amparo
                </DialogTitle>
            
                <DialogContent sx={ DialogContentStyle }>
                    
                    <Grid container spacing={3}>        
                            
                        <Grid size={{ md: 12, xs: 10 }}>
                            
                            <FormLabel>Tipo de busqueda:</FormLabel>
                            <RadioGroup row>               
                                <Grid container spacing={3} sx={{ width: '100%', mt: 1 }}>

                                    <Grid size={{ md: 4, xs: 12 }}>
                                        <FormControlLabel value="NumeroAuxiliarAmparo" control={ <Radio checked={ buscarPor === 'NumeroAuxiliarAmparo' } onChange={ () => setBuscarPor( 'NumeroAuxiliarAmparo' ) } /> } label="Por número auxiliar de amparo" />                            
                                    </Grid>

                                    <Grid size={{ md: 4, xs: 12 }}>
                                        <FormControlLabel value="NumeroAmparoOrigen" control={ <Radio checked={ buscarPor === 'NumeroAmparoOrigen' } onChange={ () => setBuscarPor( 'NumeroAmparoOrigen' ) } /> } label="Por número de amparo de origen" />                                 
                                    </Grid>

                                    <Grid size={{ md: 4, xs: 12 }}>
                                        <FormControlLabel value="NumeroExpediente" control={ <Radio checked={ buscarPor === 'NumeroExpediente' } onChange={ () => setBuscarPor( 'NumeroExpediente' ) } /> } label="Por número de expediente" />  
                                    </Grid>                                
                                
                                </Grid>              
                            </RadioGroup>

                        </Grid>                               

                        <Grid size={{ md: 6, xs: 12 }} >

                            <TextField
                                fullWidth
                                label={
                                    buscarPor === 'NumeroAuxiliarAmparo' ? 'Número auxiliar de amparo' :
                                    buscarPor === 'NumeroAmparoOrigen' ? 'Número de amparo de origen' :
                                    'Número de expediente'
                                }
                                variant="outlined"
                                slotProps={{
                                    input: {
                                        autoComplete: 'off'
                                    },
                                    inputLabel: {
                                        shrink: true,
                                    }
                                }}           
                                value={ referencia }            
                                onChange={ ( e ) => setReferencia( e.target.value ) }
                            />

                        </Grid> 

                        <Grid size={{ md: 6, xs: 12 }}>
                            
                            <Button  
                                variant="contained"     
                                loading={ loading }     
                                onClick={ Buscar }                             
                            >
                                Buscar
                            </Button >

                        </Grid>           

                        <Grid size={{ md: 12, xs: 12 }} sx={{ mt: 2 }} >
                            
                            <TableContainer sx={{ borderRadius: 3, mt: 1 }}>
                                       
                                <Table sx={{ minWidth: 500 }}>   
                                                               
                                    <TableHead sx={{ ...TableTheadStyle }}>
                    
                                        <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>  
                                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'20%' }}>Número de amparo</TableCell>
                                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'25%' }}>Tipo de amparo</TableCell>
                                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'40%' }}>Partes</TableCell>
                                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'15%' }}></TableCell>
                                        </TableRow>

                                    </TableHead>  
                                                            
                                    <TableBody>

                                        {
                                            (
                                                rowsPerPage > 0
                                                ? rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                : rows
                                            ).map( ( { idAmparo, numeroAmparo, numeroAmparoOrigen, numeroExpediente, idAutoridadAmparo, autoridadAmparo, idTipoAmparo, tipoAmparo, partes }, index ) => (

                                                <TableRow key={ index }>

                                                    <TableCell> 

                                                        {
                                                            numeroAmparo
                                                            &&
                                                                <Typography variant='h6' fontWeight={'bold'}>
                                                                    CAA. { numeroAmparo }                                                     
                                                                </Typography> 
                                                        }                                                        

                                                        {
                                                            ( numeroAmparo && numeroAmparoOrigen )
                                                            ?
                                                                <Typography variant='subtitle2' fontWeight={'normal'} fontSize={14} my={1}>
                                                                   Amparo. { numeroAmparoOrigen }                                                    
                                                                </Typography> 
                                                            :                                                
                                                                <Typography variant='h6' fontWeight={'bold'}>
                                                                    Amparo. { numeroAmparoOrigen }                                             
                                                                </Typography> 
                                                        }    

                                                        {
                                                            numeroExpediente
                                                            &&
                                                                <Typography variant='subtitle2' fontWeight={'normal'} fontSize={14}>
                                                                    EXP. { numeroExpediente }                                                    
                                                                </Typography>                                                 
                                                        }       

                                                    </TableCell>

                                                    <TableCell> 

                                                        <Typography variant='subtitle1'>
                                                            <strong>{ tipoAmparo.toUpperCase() }</strong>                                                  
                                                        </Typography> 

                                                        {
                                                            autoridadAmparo
                                                            &&
                                                                <Typography variant='subtitle2' fontWeight={'normal'} fontSize={14} my={1}>
                                                                    <strong>AUTORIDAD DEL AMPARO</strong> <br /> { autoridadAmparo.toUpperCase() }                                                    
                                                                </Typography>                                                 
                                                        }    

                                                    </TableCell>
                                                    
                                                    <TableCell> 

                                                        <List disablePadding>

                                                            {                                                            
                                                                partes.map( ({ persona, tipoParte }, index ) => (

                                                                    <ListItem key={ index } disableGutters disablePadding>
                                                                        
                                                                        <ListItemText>
                                                                            <Typography variant='subtitle1' fontSize={14}><strong>{ persona.toUpperCase() }</strong></Typography>
                                                                            <Typography variant='subtitle2' fontWeight={'normal'} fontSize={14}>({ tipoParte.toUpperCase() })</Typography>
                                                                        </ListItemText>    

                                                                    </ListItem>

                                                                ))
                                                            }

                                                        </List>

                                                    </TableCell>

                                                    <TableCell> 
                                                        <Button 
                                                            size="small"
                                                            variant="contained"
                                                            onClick={ () => { handleSeleccionar({ idAmparo, numeroAmparo, numeroAmparoOrigen, numeroExpediente, idAutoridadAmparo, autoridadAmparo, idTipoAmparo, tipoAmparo, partes }); } }
                                                            sx={{ fontSize: 12 }}
                                                        >
                                                            Seleccionar
                                                        </Button>
                                                    </TableCell>
                                                </TableRow>

                                            ))
                                        }

                                        {
                                            rows.length === 0 
                                            &&                                                    
                                                <TableRow>
                                                    <TableCell
                                                        colSpan={7}
                                                        align="center"
                                                    >
                                                        {
                                                            loading
                                                            ?
                                                                <Typography variant="caption" color='secondary'> Buscando.... </Typography>
                                                            :
                                                                <Typography variant="caption" color='secondary'> No se encontraron resultados </Typography>
                                                        }
                                                    </TableCell>
                                                </TableRow>                                                    
                                        }

                                    </TableBody>                                          
                            
                                    <TableFooter>

                                        <TableRow>
                                            <TablePagination
                                                rowsPerPageOptions={[ ]}
                                                colSpan={6}
                                                count={rows.length}                                        
                                                rowsPerPage={rowsPerPage}
                                                page={page}                                                                                
                                                onPageChange={ handleChangePage }
                                                onRowsPerPageChange={ handleChangeRowsPerPage }
                                                ActionsComponent={ TablePaginationActions }

                                                labelDisplayedRows={
                                                    ({ from, to, count }) => {
                                                      return '' + from + '-' + to + ' de ' + count
                                                    }
                                                }
                                            />
                                        </TableRow>

                                    </TableFooter>

                                </Table>
                            
                            </TableContainer>

                        </Grid>           
                        
                    </Grid>
                    
                </DialogContent>

                <DialogActions sx={ DialogActionsStyle }>
                    <Button 
                        color="secondary" 
                        onClick={ CerrarModal }
                    >
                        Cancelar
                    </Button>
                </DialogActions>

            </Dialog>
        </>
    )
}